/**
 * arfolyam service az árfolyamok lekérdezéshez tartozó servie
 * @author Koppany Kiss 2017.05.17.
 */
const MODULE_NAME = 'contactService';
class ContactService {
	constructor($http) {
		'ngInject';
		this.$http = $http;
		this.apiRoot = '/api/';
	}
	sendEmail(emailObject) {
		let objectToPost = Object.assign({}, emailObject);
		let captchaValue = objectToPost.captchaValue;
		delete objectToPost.captchaValue;
		return this.$http({
			url: `${this.apiRoot}kapcsolat/vallalati/`,
			method: 'POST',
			headers: {
				'captcha': captchaValue
			},
			data: objectToPost
		});
	}
	getVallalatiInit() {
		return this.$http.get(`${this.apiRoot}kapcsolat/vallalati/init`);
	}
	getKapcsolatInit() {
		return this.$http.get(`${this.apiRoot}kapcsolat/init`);
	}
	sendKapcsolatEmail(emailObject) {
		let objectToPost = Object.assign({}, emailObject);
		let captchaValue = objectToPost.captchaValue;
		delete objectToPost.captchaValue;
		return this.$http({
			url: `${this.apiRoot}kapcsolat/`,
			method: 'POST',
			headers: {
				'captcha': captchaValue
			},
			data: objectToPost
		});
	}
}

export default angular.module(MODULE_NAME, []).service('contactService', ContactService).name;



// WEBPACK FOOTER //
// ../source/application/services/contact-service.js